import {StateCreator} from 'zustand'
import type {IBreadcrumb} from '../../types'

export interface IHomeStore {
  breadcrumbs: IBreadcrumb[]
  setBreadcrumb: (crumbs: IBreadcrumb[]) => void
}

export const createHomeSlice: StateCreator<
  IHomeStore,
  [],
  [],
  IHomeStore
> = set => ({
  breadcrumbs: [],
  setBreadcrumb: crumbs => set({breadcrumbs: crumbs}),
})
